import React from "react";
import { Col, Row } from "antd";
import { wrap } from "../../helpers/array";

export interface FooterProps {
  children?: React.ReactNode | React.ReactNode[];
}

const Footer: React.FC<FooterProps> = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div className="card__footer">
      <Row gutter={15}>
        {wrap(children).map((component, index) => (
          <Col key={index.toString()}>{component}</Col>
        ))}
      </Row>
    </div>
  );
};

export default Footer;
